import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

import { MenuState } from '../../store/state/menu.state';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
})
export class LogoComponent {
    @Select(MenuState.isOpen) public isMenuOpen$: Observable<boolean>;
}
